export default "__VITE_ASSET__BLIfl9Rl__"